import { useTranslations } from '@vocab/react';
import { Bleed, Box, Heading, Stack, Text } from 'braid-design-system';

import translations from '../.vocab';

import Hand from './Hand';

import { SuccessBannerStyle } from './SuccessBanner.css';

export const SuccessBanner = () => {
  const { t } = useTranslations(translations);

  return (
    <Bleed>
      <Box
        background="customDark"
        paddingY="xlarge"
        paddingX="xlarge"
        borderRadius="xlarge"
        width="full"
        className={SuccessBannerStyle}
      >
        <Stack space="small" align="center">
          <Hand />
          <Heading level="2" align="center">
            {t('nice one')}!
          </Heading>
          <Text align="center">{t('You are now...')}</Text>
        </Stack>
      </Box>
    </Bleed>
  );
};
